import axios from "@/api/axiosInstance";
import { UpdateSpecialtyRequest, UpdateSpecialtyResponse } from "./types";

export const updateSpecialty = async (
  uuid: string,
  requestData: UpdateSpecialtyRequest,
): Promise<UpdateSpecialtyResponse> => {
  const response = await axios.put<UpdateSpecialtyResponse>(
    `/api/private/employee-directory/specialties/${uuid}`,
    requestData,
  );
  return response.data;
};
